






























import { getMessageById } from '@/utils/message';
import Vue, { PropType } from 'vue';

export enum EcharGroup {
  non = 'non',
  num = 'num',
  alphanum = 'alphanum',
}

declare interface IMethods {
  onInput: (value: string) => void;
}

declare interface IComputed {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputRules: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  displayCounter: any;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, IMethods, IComputed, any>({
  name: 'CtrlTextArea',
  props: {
    label: { required: false, type: String, default: '' },
    required: { required: false, type: Boolean },
    placeholder: { required: true, type: String },
    charGroup: { required: true, type: String as PropType<EcharGroup> },
    length: { type: Number, default: 250 },
    value: { required: false, type: [String, Number], default: '' },
    appendRules: { required: false, type: Array, default: () => [] },
    inputDigitDisplay: { type: Boolean, default: false },
    showToolTip: { required: false, type: Boolean, default: false },
  },

  data() {
    return {
      textValue: '',
      id: '',
      rules: {
        counter: (value: string) => {
          return (
            value.toString().length <= this.length ||
            `${getMessageById('KI_W010')} ${this.length}`
          );
        },
        required: (value: string) => !!value || getMessageById('KI_W007'),
      },
    };
  },

  watch: {
    value() {
      this.textValue = this.value;
    },
  },

  computed: {
    inputRules() {
      return this.required
        ? [this.rules.counter, this.rules.required, ...this.appendRules]
        : [this.rules.counter, ...this.appendRules];
    },
    displayCounter() {
      // High prioty
      if (
        ('readonly' in this.$attrs || 'disabled' in this.$attrs) &&
        (this.$attrs.readonly === '' ||
          this.$attrs.readonly === 'true' ||
          this.$attrs.readonly ||
          this.$attrs.disabled === '' ||
          this.$attrs.readonly === 'true')
      ) {
        return false;
      }

      return this.inputDigitDisplay ? this.length : false;
    },
  },
  methods: {
    onInput(value: string) {
      let newValue = '';

      switch (this.charGroup) {
        case EcharGroup.num:
          newValue = value.replace(/[^0-9]/g, '');
          break;

        case EcharGroup.alphanum:
          newValue = value.replace(/[^a-zA-Z0-9]/g, '');
          break;

        default:
          newValue = value;
          break;
      }

      const self = this;
      this.$nextTick(() => {
        self.textValue = newValue;
        this.$emit('input', newValue);
      });
    },
  },
  created() {
    this.textValue = this.value;
  },
});
